// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import Resource from 'vue-resource'

Vue.use(Resource)

Vue.config.productionTip = false

import storage from "./storage/data.js";
Vue.http.headers.common['Authorization'] = storage.data.session.id;

import App from './App'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  created:function(){
    let self = this;
    Vue.http.interceptors.push((request, next)  => {
        // Bloquer les requêtes si on est sur une route qui nécessite une authentification et qu'on est déco.

        if(self.$route.meta.requiresAuth && storage.data.session.authenticated){
          next((response) => {
              // Si token invalid alors la session a expirée. On se déco.
              if(response && response.data && response.data.error && response.data.error.code == "INVALID_TOKEN"){
                storage.logout();
                // console.log("SELF ROUTE",self.$route)
                toastr.clear();
                toastr.error("Votre session a expirée.","ERREUR");
                self.$router.push({name:"login",query:{redirect:self.$route.fullPath}});
              }
              if(response.status <= 304 && storage.data &&  storage.data.session && storage.data.session.userId){
                // Refresh du token +1h.
                storage.refreshToken(self);
              }
          });
        }
        else if(!self.$route.meta.requiresAuth){
          next();
        }

    });
  },
  mounted:function(){
    // console.log("THIS ROOT",this)

    this.$on("loading",function(value,text,forceValue){
      this.$children[0].$emit('loading',value,text,forceValue);
    })

    this.$on("progressBar",function(enabled,min,max,val,text){
      this.$children[0].$emit('progressBar',enabled,min,max,val,text);
    })

  },
  components: { App }
})

router.beforeEach((to, from, next) => {
  // window.scrollTo(0, 0)  > Remplacer par la fonction scrollBehavior dans router. 
  // Si utilisateur déco, rediriger vers le login.
  // console.log("ROUTER BEFORE EARCH",to,from);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if(storage && storage.data && storage.data.session && storage.data.session.authenticated === true){
      next();
    }
    else{
      next({name:"login",query:{redirect:to.fullPath}});
      // next({
      //   path: '/login',
      //   query: { redirect: to.fullPath }
      // })
    }
  } else {
    next() // make sure to always call next()!
  }

})



// WEBPACK FOOTER //
// ./src/main.js